/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Promotion order entry consumed
 * @export
 * @interface PromotionOrderEntryConsumed
 */
export interface PromotionOrderEntryConsumed {
    /**
     * Order entry code
     * @type {string}
     * @memberof PromotionOrderEntryConsumed
     */
    code?: string;
    /**
     * Adjusted unit price for promotion order entry
     * @type {number}
     * @memberof PromotionOrderEntryConsumed
     */
    adjustedUnitPrice?: number;
    /**
     * Order entry number
     * @type {number}
     * @memberof PromotionOrderEntryConsumed
     */
    orderEntryNumber?: number;
    /**
     * Quantity of promotion order entry
     * @type {number}
     * @memberof PromotionOrderEntryConsumed
     */
    quantity?: number;
}

/**
 * Check if a given object implements the PromotionOrderEntryConsumed interface.
 */
export function instanceOfPromotionOrderEntryConsumed(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PromotionOrderEntryConsumedFromJSON(json: any): PromotionOrderEntryConsumed {
    return PromotionOrderEntryConsumedFromJSONTyped(json, false);
}

export function PromotionOrderEntryConsumedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionOrderEntryConsumed {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'adjustedUnitPrice': !exists(json, 'adjustedUnitPrice') ? undefined : json['adjustedUnitPrice'],
        'orderEntryNumber': !exists(json, 'orderEntryNumber') ? undefined : json['orderEntryNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}

export function PromotionOrderEntryConsumedToJSON(value?: PromotionOrderEntryConsumed | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'adjustedUnitPrice': value.adjustedUnitPrice,
        'orderEntryNumber': value.orderEntryNumber,
        'quantity': value.quantity,
    };
}

